export default __webpack_public_path__ + "static/media/pro_icon_yellow.b93c18d1.svg";